"use strict"

angular.module("core")
.service("PaymentService", function(
    $resource, $http, FlashBag, ZebraPrinterService, ReadOnlyPermissionService, gettextCatalog, common, appConfig
) {
    var resource = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/payments/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    var pdfResource = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/payment/pdf/:id/:pdfFormat/:outputType/", {
        id: "@id",
        pdfFormat: "@pdfFormat",
        outputType: "@outputType"
    }, {
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.get = function(id) {
        return resource.get({id: id});
    };

    this.query = function(params) {
        return resource.query(params);
    };

    this.queryUnpaidInvoices = function(params) {
        var resource = $resource(appConfig.API_SERVER + "/invoice/customer/unpaid/", {}, {
            query: {
                method: "GET",
                isArray: true,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.query(params);
    };

    this.create = function(data) {
        var resource = $resource(appConfig.API_SERVER + "/invoice/customer/payment/", {}, {
            create: {
                method: "POST",
                interceptor: {responseError: ReadOnlyPermissionService.responseErrorInterceptor}
            }
        });
        return (new resource(data)).$create();
    };

    function createReceiptPDF(paymentId) {
        var resource =  $resource(appConfig.API_SERVER + "/invoice/customer/payment/pdf/"+ paymentId + "/receipt/print/", {}, {
            create: {
                method: "POST",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });

        return (new resource()).$save()
    }

    this.downloadReceiptPDF = function(paymentId) {
        createReceiptPDF(paymentId).then(function(data) {
            var file_data = data.file_data;
            if (file_data) {
                var file_name = data.file_name;
                common.downloadFile(file_data, file_name, {type: "application/pdf;charset=utf-8;"});
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There is an error while trying to generate the file."));
            }
        });
    };

    this.printReceiptPDF = function(paymentId) {
        createReceiptPDF(paymentId).then(function onSuccess(data) {
            return ZebraPrinterService.defaultResponseCallback(data)
        });
    };

    this.downloadPDF = function(id, pdfFormat) {
        return pdfResource.save(
            {
                id: id,
                pdfFormat: pdfFormat,
                outputType: "print"
            }
        );
    };

    this.getStatusNamesLocalized = function() {
        var resource = $resource(appConfig.API_SERVER + "/invoice/payments/status-names/translations/", {}, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
        return resource.get();
    };

    this.getAllowedPaymentMethodChoicesLocalized = function(vendorId) {
        return $http.get(appConfig.API_SERVER + "/payment-methods/allowed-payment-method-choices/translations/?vendor_id=" + vendorId);
    };

    this.getVendorAllowedPaymentMethodChoicesLocalized = function() {
        return $http.get(appConfig.API_SERVER + "/payment-methods/vendor/allowed-payment-method-choices/translations/");
    };

    this.getVendorAllowedPreAuthorizedPaymentMethodChoicesLocalized = function() {
        return $http.get(appConfig.API_SERVER + "/payment-methods/vendor/allowed-pre-authorized-payment-method-choices/translations/");
    };

    this.getAvailableSortFields = function() {
        return {
            customer_name: {
                name: gettextCatalog.getString("Name"),
                normal: gettextCatalog.getString("A to Z"),
                reverse: gettextCatalog.getString("Z to A")
            },
            buyer_number: {
                name: gettextCatalog.getString("Customer #"),
                normal: gettextCatalog.getString("0 to 9"),
                reverse: gettextCatalog.getString("9 to 0")
            },
            status_date: {
                name: gettextCatalog.getString("Status Date"),
                normal: gettextCatalog.getString("Past to Future"),
                reverse: gettextCatalog.getString("Future to Past")
            }
        };
    };

    this.getSortFields = function() {
        return common.getSortFieldsByKeys(
            "customer_name, buyer_number, status_date",
            this.getAvailableSortFields()
        );
    };

    this.getStatusFilterValues = function() {
        return {
            in_progress: gettextCatalog.getString("In Progress"),
            cancelled: gettextCatalog.getString("Cancelled"),
            failed: gettextCatalog.getString("Failed"),
            successful: gettextCatalog.getString("Successful")
        }
    };

    this.getPaymentCheckNumberHtmlContent = function() {
        return gettextCatalog.getString("Payment Check Number help tip html");
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment/payment.service.js
// module id = 440
// module chunks = 0